import { Center, Loader, Box } from '@qred/components-library';
import React, { useState, useRef, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import { useSelector } from 'react-redux';
import { logToSentry } from '~/helpers/loggers.helper';
import { RootState } from '~/store';

interface PDFViewerProps {
  file: string;
}

const PDFViewer = ({ file }: PDFViewerProps) => {
  const [totalPages, setTotalPages] = useState<number>();
  const { mobile } = useSelector((state: RootState) => state.matchedMedia);
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setTotalPages(numPages);
  };

  const onDocumentLoadError = (error: Error) => {
    logToSentry(error, 'PDFViewerError');
  };

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current && !mobile) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [mobile]);

  return (
    <Box ref={containerRef} w="100%">
      <Document
        file={file}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={
          <Center>
            <Loader size={'xl'} />
          </Center>
        }
      >
        {[...Array(totalPages)]
          .map((_, i) => i + 1)
          .map((page, key) => (
            <Page
              key={key}
              pageNumber={page}
              width={mobile ? window.screen.width : containerWidth || undefined}
              scale={mobile ? 1 : undefined}
            />
          ))}
      </Document>
    </Box>
  );
};

export default PDFViewer;
